// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobileCategoryHeader {
  display: flex;
  justify-content: space-between;
  flex-shrink: 0;
  font-size: 1.25rem;
  font-weight: 700;
  margin-bottom: 6px;
}

.mobileCategoryData {
  flex: 1;
  overflow-y: auto;
  margin-top: 8px;
}

.mobileEmptyCatData {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-weight: 700;
  font-size: 1rem;
}

.mobileCategoryList {
  list-style: none;
  padding: 0;
  margin: 0;
}

.mobileCategoryItems {
  padding: 8px 0px;
  font-weight: 700;
  border-bottom: 0.5px solid var(--surface-g1);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.mobileCatLoader {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/MobileCategoryPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd","sourcesContent":[".mobileCategoryHeader {\n  display: flex;\n  justify-content: space-between;\n  flex-shrink: 0;\n  font-size: 1.25rem;\n  font-weight: 700;\n  margin-bottom: 6px;\n}\n\n.mobileCategoryData {\n  flex: 1;\n  overflow-y: auto;\n  margin-top: 8px;\n}\n\n.mobileEmptyCatData {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  font-weight: 700;\n  font-size: 1rem;\n}\n\n.mobileCategoryList {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.mobileCategoryItems {\n  padding: 8px 0px;\n  font-weight: 700;\n  border-bottom: 0.5px solid var(--surface-g1);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.mobileCatLoader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
